import { espacesUniquesKeys } from '../utils'
import CustomAppBar from './custom_app_bar'
import MyMenu from './menu'
import { Layout, useResourceContext } from 'react-admin'
import { makeStyles, Box } from '@material-ui/core'
import { useLocation } from 'react-router'
import InternalError from '../error_pages/InternalError'
import backGround from '../assets/images/Fond-Manda.svg'

import ExtranetAppBar from './extranet_app_bar'
import usePageTracking from '../hooks/usePageTracking'
import CustomSidebar from './custom_sidebar'

const useStyles = makeStyles({
  wrapper: {
    backgroundImage: `url(${backGround})`,
    minHeight: 'calc(100vh)',
    backgroundSize: 'cover',
    backgroundAttachment: 'fixed',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    position: 'relative',
    overflow: 'hidden',
  },
  secondWrapper: {
    background:
      'linear-gradient(-45deg, rgba(255, 118, 117, 0.3), rgba(252, 204, 96, 0.3), rgba(31,172,216,0.3))',
    minHeight: 'calc(100vh)',
    backgroundSize: '400% 400%',
    animation: '$gradient 8s ease infinite',
  },
  '@keyframes gradient': {
    '0%': {
      backgroundPosition: '0% 50%',
    },
    '50%': {
      backgroundPosition: '100% 50%',
    },
    '100%': {
      backgroundPosition: '0% 50%',
    },
  },
  mainBar: {
    position: 'fixed',
    marginBottom: '16px',
    zIndex: 1000,
    background: 'black',
  },
})

const MyLayout = (props) => {
  usePageTracking()
  const classes = useStyles()
  const location = useLocation()
  const unauthorized =
    location.pathname.indexOf('/unauthorized') !== -1 ||
    location.pathname.indexOf('/account_disabled') !== -1
  const isInPagesPvags =
    location.pathname.indexOf('/pvags/') !== -1 ||
    location.pathname.indexOf('/pvagsconvocation/') !== -1 ||
    location.pathname.indexOf('/pvagsfeuillepresence/') !== -1 ||
    location.pathname.indexOf('/convocation/') !== -1
  const isZendeskPlugin = location.pathname === '/zendesk_plugin_tickets'
  if (
    location.pathname.indexOf(espacesUniquesKeys['frontplugintickets']) !== -1
  ) {
    return unauthorized ? (
      <>{props.children}</>
    ) : (
      <Box>
        <Box style={{ paddingBottom: '76px' }}>{props.children}</Box>
      </Box>
    )
  } else if (
    unauthorized ||
    location.pathname.indexOf(espacesUniquesKeys['prestas']) !== -1 ||
    location.pathname.indexOf(espacesUniquesKeys['ext_login']) !== -1 ||
    location.pathname.indexOf(espacesUniquesKeys['cs']) !== -1 ||
    location.pathname.indexOf(espacesUniquesKeys['ag']) !== -1 ||
    location.pathname.indexOf('/convocation/') !== -1 ||
    location.pathname === espacesUniquesKeys['ag2'] ||
    location.pathname === espacesUniquesKeys['ag3'] ||
    location.pathname.indexOf(espacesUniquesKeys['pvag']) !== -1 ||
    location.pathname.indexOf(espacesUniquesKeys['mec']) !== -1 ||
    location.pathname.indexOf(espacesUniquesKeys['copro']) !== -1 ||
    location.pathname.indexOf(espacesUniquesKeys['coproprietaires']) !== -1 ||
    location.pathname.indexOf(espacesUniquesKeys['coprofiche']) !== -1 ||
    location.pathname.indexOf(espacesUniquesKeys['coprotickets']) !== -1 ||
    location.pathname.indexOf(espacesUniquesKeys['invoices']) !== -1 ||
    location.pathname.indexOf(espacesUniquesKeys['concent_template']) !== -1 ||
    isZendeskPlugin
  ) {
    return unauthorized || isZendeskPlugin ? (
      <>{props.children}</>
    ) : (
      <div className={isInPagesPvags ? classes.secondWrapper : classes.wrapper}>
        {location.pathname.indexOf(espacesUniquesKeys['coproprietaires']) ==
          -1 &&
          location.pathname.indexOf(espacesUniquesKeys['ext_login']) == -1 && (
            <ExtranetAppBar {...props} className={classes.mainBar} />
          )}

        <Box sx={{ zIndex: 299, position: 'relative' }}>
          <Box style={{ paddingTop: '60px' }}>{props.children}</Box>
        </Box>
      </div>
    )
  } else {
    return (
      <Layout
        {...props}
        menu={CustomSidebar}
        appBar={CustomAppBar}
        error={InternalError}
        className="LAYOUT_CUSTOM"
      />
    )
  }
}

export default MyLayout
